import React from "react";
import { CheckIcon } from "@packages/shared-components/user-profile/signin-signup/media-utilities/mediautilities";

const CustomCheckbox = ({
  children,
  checked = false,
  defaultChecked = false,
  onChange,
}: {
  children: React.ReactNode;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
}) => (
  <label className="flex items-start gap-[12px] cursor-pointer">
    <input
      type="checkbox"
      className="peer hidden"
      {...(onChange ? { checked, onChange: (e) => onChange(e.target.checked) } : { defaultChecked })}
    />
    <div className="w-[16px] h-[16px] mt-[1px] border border-grey-400 rounded flex items-center justify-center peer-checked:bg-blue-400 peer-checked:border-blue-400 [&>svg]:opacity-0 peer-checked:[&>svg]:opacity-100 flex-shrink-0">
      <CheckIcon />
    </div>
    <span className="x-small text-grey-600">{children}</span>
  </label>
);

export default CustomCheckbox;
